import AjaxClass from '../modules/Forms/Validation/ajaxClass.js';

const CATEGORIES_DATA = window.SIM_CATEGORIES_DATA || {};

const CATEGORY_KEYS = Object.keys(CATEGORIES_DATA);

// ── State ──────────────────────────────────────────────────────────────────
const state = {
    selectedCategory:  'RESIDENCES CLUB',
    selectedProperty:  CATEGORIES_DATA['RESIDENCES CLUB'][0],
    selectedUnit:      CATEGORIES_DATA['RESIDENCES CLUB'][0].units[0],
    hasReinforcements: true,
    paymentTerm:       55,
    entryPercentage:   25,
    sliderIndex:       0,
    galleryCategory:   'RESIDENCES CLUB',
};

let sliderTimer    = null;
let sliderBusy     = false;
let userInteracted = false;

// ── Helpers ────────────────────────────────────────────────────────────────
function buildUnitParam(categoryKey, unitName) {
    const cat = (categoryKey || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    const num = ((unitName || '').match(/\d+/) || [''])[0];
    return cat + '-' + num;
}

function fmt(val) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
}

function el(id) { return document.getElementById(id); }

function setText(id, val) {
    const node = el(id);
    if (node) node.textContent = val;
}

function setVisible(id, show) {
    const node = el(id);
    if (node) node.style.display = show ? '' : 'none';
}

function imgSrc(path) {
    const base = (window.SIM_IMG_BASE || '').replace(/\/$/, '');
    return base ? `${base}/${path}` : `/${path}`;
}

function galleryUnits() {
    const out = [];
    (CATEGORIES_DATA[state.galleryCategory] || []).forEach(prop => {
        prop.units.forEach(unit => {
            console.log(unit);
            
            out.push({ ...unit, propertyId: prop.id, propertyTitle: prop.title, specs: prop.specs, area: prop.area, rooms: prop.rooms, img: unit.img ?? prop.unit, categoryKey: state.galleryCategory });
        });
    });
    return out;
}

function cpp() {
    const w = window.innerWidth;
    if (w < 768) return 1;
    if (w < 992) return 2;
    return 3;
}

// ── Slider ─────────────────────────────────────────────────────────────────
function renderSlider() {
    const grid = el('simGrid');
    const dots = el('simDots');
    if (!grid || !dots) return;

    grid.classList.remove('sim-gallery__grid--leaving-next', 'sim-gallery__grid--leaving-prev');
    grid.innerHTML = '';
    dots.innerHTML = '';

    const units = galleryUnits();
    if (!units.length) return;

    const perPage    = cpp();
    const totalPages = Math.ceil(units.length / perPage);
    if (state.sliderIndex >= totalPages) state.sliderIndex = 0;

    units.slice(state.sliderIndex * perPage, (state.sliderIndex + 1) * perPage).forEach(unit => {
        const match = unit.name.match(/^(RES \d+|APTO \d+|SALA \d+)/i);
        const badge = match ? match[1] : unit.name;

        const card = document.createElement('article');
        card.className = 'sim-card';
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-label', `Simular ${unit.propertyTitle}`);
        card.innerHTML = `
            <div class="sim-card__image">
                <img src="${unit.img}" alt="${unit.propertyTitle}" loading="lazy" width="480" height="360">
                <span class="sim-card__badge">${badge}</span>
            </div>
            <div class="sim-card__body">
                <div>
                    <span class="sim-card__category">${unit.categoryKey}</span>
                    <h3 class="sim-card__title">${unit.propertyTitle}</h3>
                    <div class="sim-card__specs">
                        ${unit.area ? `
                        <span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" aria-hidden="true">
                                <path d="M4 8V4h4M4 4l5 5M20 8V4h-4M20 4l-5 5M4 16v4h4M4 20l5-5M20 16v4h-4M20 20l-5-5"/>
                            </svg>
                            ${unit.area}
                        </span>
                        ` : ''}
                        
                        ${unit.rooms ? `
                        <span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" aria-hidden="true">
                                <path d="M3 10V19a1 1 0 001 1h16a1 1 0 001-1v-9M3 10l9-5 9 5M3 10h18M9 20v-5m6 5v-5M12 20v-5"/>
                            </svg>
                            ${unit.rooms}
                        </span>
                        ` : ''}
                    </div>
                </div>
                <div class="sim-card__footer">
                    <div>
                        <span class="sim-card__price-label">Preço de Tabela</span>
                        <span class="sim-card__price">${fmt(unit.price)}</span>
                    </div>
                    <span class="sim-card__cta">
                        Simular agora
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke-width="2.5" aria-hidden="true">
                            <path d="M14 5l7 7m0 0l-7 7m7-7H3"/>
                        </svg>
                    </span>
                </div>
            </div>`;

        const open = () => onCardClick(unit.categoryKey, unit.propertyId, unit.name);
        card.addEventListener('click', open);
        card.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
        grid.appendChild(card);
    });

    for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'sim-gallery__dot' + (i === state.sliderIndex ? ' sim-gallery__dot--active' : '');
        dot.setAttribute('aria-label', `Página ${i + 1}`);
        dot.addEventListener('click', () => { markInteracted(); setPage(i); });
        dots.appendChild(dot);
    }

    const gallerySelect = el('simGallerySelect');
    if (gallerySelect) gallerySelect.value = state.galleryCategory;
}

function animateSlider(dir, updateFn) {
    if (sliderBusy) return;
    sliderBusy = true;
    stopAutoplay();

    const grid = el('simGrid');
    grid.classList.add(dir === 'prev' ? 'sim-gallery__grid--leaving-prev' : 'sim-gallery__grid--leaving-next');

    setTimeout(() => {
        updateFn();
        renderSlider();
        sliderBusy = false;
        startAutoplay();
    }, 280);
}

function setPage(idx) {
    if (idx === state.sliderIndex) return;
    animateSlider(idx > state.sliderIndex ? 'next' : 'prev', () => { state.sliderIndex = idx; });
}

function prevSlide() {
    markInteracted();
    const units    = galleryUnits();
    const perPage  = cpp();
    const total    = Math.ceil(units.length / perPage);

    if (state.sliderIndex === 0) {
        const ci = CATEGORY_KEYS.indexOf(state.galleryCategory);
        state.galleryCategory = CATEGORY_KEYS[(ci - 1 + CATEGORY_KEYS.length) % CATEGORY_KEYS.length];
        const newUnits = galleryUnits();
        state.sliderIndex = Math.ceil(newUnits.length / perPage) - 1;
        animateSlider('prev', () => {});
    } else {
        animateSlider('prev', () => { state.sliderIndex--; });
    }
}

function nextSlide(isUser = false) {
    if (isUser) markInteracted();
    const units   = galleryUnits();
    const perPage = cpp();
    const total   = Math.ceil(units.length / perPage);

    if (state.sliderIndex >= total - 1) {
        const ci = CATEGORY_KEYS.indexOf(state.galleryCategory);
        state.galleryCategory = CATEGORY_KEYS[(ci + 1) % CATEGORY_KEYS.length];
        state.sliderIndex = 0;
        animateSlider('next', () => {});
    } else {
        animateSlider('next', () => { state.sliderIndex++; });
    }
}

function startAutoplay() {
    if (userInteracted || sliderTimer) return;
    sliderTimer = setInterval(() => nextSlide(false), 5200);
}

function stopAutoplay() {
    clearInterval(sliderTimer);
    sliderTimer = null;
}

function markInteracted() {
    userInteracted = true;
    stopAutoplay();
}

// Touch swipe
let touchX = 0;
function initTouch() {
    const grid = el('simGrid');
    if (!grid) return;
    grid.addEventListener('touchstart', e => { touchX = e.changedTouches[0].screenX; }, { passive: true });
    grid.addEventListener('touchend', e => {
        const diff = touchX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) { markInteracted(); diff > 0 ? nextSlide() : prevSlide(); }
    }, { passive: true });
}

// ── Drawer ─────────────────────────────────────────────────────────────────
function openDrawer() {
    const drawer = el('simDrawer');
    const panel  = el('simPanel');
    if (!drawer || !panel) return;

    drawer.classList.add('sim-drawer--open');
    document.body.style.overflow = 'hidden';
    if (window.lenis) window.lenis.stop();
    syncDrawerSelects();

    const url = new URL(window.location.href);
    url.searchParams.set('unit', buildUnitParam(state.selectedCategory, state.selectedUnit && state.selectedUnit.name));
    history.replaceState(null, '', url);

    requestAnimationFrame(() => {
        requestAnimationFrame(() => panel.classList.add('sim-drawer__panel--open'));
    });
}

function closeDrawer() {
    const drawer = el('simDrawer');
    const panel  = el('simPanel');
    if (!drawer || !panel) return;

    panel.classList.remove('sim-drawer__panel--open');
    document.body.style.overflow = '';
    if (window.lenis) window.lenis.start();

    const url = new URL(window.location.href);
    url.searchParams.delete('unit');
    history.replaceState(null, '', url);

    setTimeout(() => drawer.classList.remove('sim-drawer--open'), 400);
}

function syncDrawerSelects() {
    const catSel = el('simSelectCategory');
    if (catSel) {
        catSel.value = state.selectedCategory;
        populateProperties();
    }
    updateCalc();
}

// ── Card click ─────────────────────────────────────────────────────────────
function onCardClick(category, propertyId, unitName) {
    markInteracted();
    state.selectedCategory  = category;
    state.selectedProperty  = CATEGORIES_DATA[category].find(p => p.id === propertyId);
    state.selectedUnit      = state.selectedProperty.units.find(u => u.name === unitName);
    state.entryPercentage   = 25;
    state.paymentTerm       = 55;
    state.hasReinforcements = true;
    openDrawer();
}

// ── Selects ─────────────────────────────────────────────────────────────────
function populateProperties() {
    const sel = el('simSelectProperty');
    if (!sel) return;
    sel.innerHTML = '';
    CATEGORIES_DATA[state.selectedCategory].forEach(p => {
        const opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.title;
        sel.appendChild(opt);
    });
    sel.value = state.selectedProperty.id;
    populateUnits();
}

function populateUnits() {
    const sel = el('simSelectUnit');
    if (!sel) return;
    sel.innerHTML = '';
    state.selectedProperty.units.forEach(u => {
        const opt = document.createElement('option');
        opt.value = u.name;
        opt.textContent = u.name;
        sel.appendChild(opt);
    });
    sel.value = state.selectedUnit.name;
    updateCalc();
}

// ── Calculation ─────────────────────────────────────────────────────────────
function updateCalc() {
    const price   = state.selectedUnit.price;
    const entry   = (price * state.entryPercentage) / 100;
    const delivery = price * 0.30;
    const term    = state.paymentTerm;
    const hasRef  = state.hasReinforcements;

    let baloesCount = 0;
    if (hasRef) {
        if (term >= 55)      baloesCount = 5;
        else if (term >= 48) baloesCount = 4;
        else if (term >= 24) baloesCount = 2;
        else                 baloesCount = 1;
    }

    let refUnit = 0, refTotal = 0, monthly = 0;

    if (term === 55 && state.entryPercentage === 25) {
        // Use table values (exact)
        if (hasRef) {
            refUnit  = state.selectedUnit.withRef.ref;
            refTotal = refUnit * 5;
            monthly  = state.selectedUnit.withRef.pay70;
        } else {
            monthly = state.selectedUnit.noRef.pay70;
        }
    } else {
        // Proportional estimate
        refUnit  = price * 0.05;
        refTotal = baloesCount * refUnit;
        const residual = price - entry - delivery - refTotal;
        monthly = Math.max(residual / term, 0);
    }

    const financed = price - entry - refTotal - delivery;

    setText('simUnitName',    state.selectedUnit.name);
    setText('simUnitDesc',    state.selectedProperty.specs);
    setText('simUnitPrice',   fmt(price));
    setText('simEntryPct',    state.entryPercentage);
    setText('simEntryVal',    fmt(entry));
    setText('simTermLabel',   `${term} meses`);
    setText('simSumFinanced', fmt(financed));
    setText('simSumEntry',    fmt(entry));
    setText('simSumRef',      fmt(refTotal));
    setText('simSumDelivery', fmt(delivery));
    setText('simMonthly',     fmt(monthly));

    // Reinforcements visibility
    setVisible('simSumRefRow', hasRef);
    setVisible('simRefInfo',   hasRef);
    if (hasRef) {
        setText('simRefQty', baloesCount);
        setText('simRefVal', fmt(refUnit));
    }

    // Active states — entry buttons
    el('simEntryGroup')?.querySelectorAll('[data-entry]').forEach(btn => {
        btn.classList.toggle('sim-btn-opt--active', btn.dataset.entry === String(state.entryPercentage));
    });

    // Active states — term buttons
    el('simTermGroup')?.querySelectorAll('[data-term]').forEach(btn => {
        btn.classList.toggle('sim-btn-opt--active', btn.dataset.term === String(term));
    });

    // Active states — ref toggle
    el('simRefToggle')?.querySelectorAll('[data-ref]').forEach(btn => {
        btn.classList.toggle('sim-ref-toggle__btn--active', (btn.dataset.ref === 'true') === hasRef);
    });

    function setHidden(id, val) {
        const node = el(id);
        if (node) node.value = val;
    }

    setHidden('simHiddenCategory',       state.selectedCategory);
    setHidden('simHiddenPropertyTitle',  state.selectedProperty.title);
    setHidden('simHiddenUnitName',       state.selectedUnit.name);
    setHidden('simHiddenUnitPrice',      price);
    setHidden('simHiddenEntryPct',       state.entryPercentage);
    setHidden('simHiddenEntryVal',       entry);
    setHidden('simHiddenTerm',           state.paymentTerm);
    setHidden('simHiddenHasRef',         state.hasReinforcements ? '1' : '0');
    setHidden('simHiddenMonthly',        monthly);
    setHidden('simHiddenFinanced',       financed);
    setHidden('simHiddenDelivery',       delivery);
    setHidden('simHiddenRefTotal',       refTotal);
}

// ── Lead form ───────────────────────────────────────────────────────────────
function submitLead(e) {
    e.preventDefault();
    const name  = el('simLeadName')?.value.trim();
    const phone = el('simLeadPhone')?.value.trim();
    if (!name || !phone) return;

    const form    = el('simLeadForm');

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
        const formName =
            form.getAttribute('data-name')?.trim() ||
            form.id ||
            'Formulário';

        dataLayer.push({
            event: 'formSubmit',
            formName: formName
        });
    }

    let fields = Array.from(new FormData(form).entries()).map(([name, value]) => ({ name, value }));

    const sanitizeInput = (str) => {
        if (typeof str !== 'string') return str;
        return str.replace(/<[^>]*>?/gm, ''); // Remove qualquer tag HTML
    };

    let formData = new FormData(form);

    fields.forEach(obj => {
        if (obj.value && typeof obj.value === 'string') {
            obj.value = sanitizeInput(obj.value);
        }
        formData.append(obj.name, obj.value);
    });

    form.disabled = true;
    let type = 'POST';
    let url = form.action;
    let dataType = 'json';

    const modalError = document.getElementById('error-message-forms');
    const modalDescription = document.querySelector('#error-message-forms .description');
    const Loader = document.getElementById("loading-forms");
    Loader.classList.add("open-modal");
    class Form extends AjaxClass {
        successFunction(data, form) {
            Loader.classList.remove("open-modal");
            if (data.status === true) {
                const success = el('simSuccess');
                success.classList.add('sim-success--visible');
                form.reset();
                form.disabled = false;
                if (form)    form.style.display = 'none';
            } else {
                modalDescription.innerHTML = data.txt;
                modalError.classList.add("open-modal");
                form.disabled = false;
            }
        }

        errorFunction(xhr, textStatus, errorThrown) {
            Loader.classList.remove("open-modal");
            modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";

            if (errorThrown === 'Too Many Requests' || xhr.responseText === 'Too Many Requests') {
                modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
            }

            if (xhr.status === 419) {
                // CSRF expirado
                modalDescription.innerHTML = "Sessão expirada. Recarregando...";
                setTimeout(() => location.reload(), 2000);
            }

            modalError.classList.add("open-modal");
            form.disabled = false;
        }
    }

    let ajax = new Form(form, type, url, dataType, formData);
    ajax.send();

    return false;
}

function resetLead() {
    const form    = el('simLeadForm');
    const success = el('simSuccess');
    if (el('simLeadName'))  el('simLeadName').value  = '';
    if (el('simLeadPhone')) el('simLeadPhone').value = '';
    if (form)    form.style.display = '';
    if (success) success.classList.remove('sim-success--visible');
}

// ── Preloader ──────────────────────────────────────────────────────────────
(function () {
    function hideSimLoader() {
        const loader = document.querySelector('.home-loader');
        if (!loader) return;
        document.documentElement.style.overflow = 'auto';
        document.body.style.background = '';
        loader.classList.add('hidden');
        loader.addEventListener('transitionend', () => loader.remove(), { once: true });
    }

    if (document.readyState === 'complete') {
        hideSimLoader();
    } else {
        window.addEventListener('load', hideSimLoader, { once: true });
        // Fallback: remove após 5s mesmo se algum asset travar
        setTimeout(hideSimLoader, 5000);
    }
}());

// ── Init ───────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
    renderSlider();
    startAutoplay();
    initTouch();
    syncDrawerSelects();

    // Hero CTA
    el('simCTABtn')?.addEventListener('click', () => {
        state.selectedCategory  = 'RESIDENCES CLUB';
        state.selectedProperty  = CATEGORIES_DATA['RESIDENCES CLUB'][0];
        state.selectedUnit      = state.selectedProperty.units[0];
        state.entryPercentage   = 25;
        state.paymentTerm       = 55;
        state.hasReinforcements = true;
        openDrawer();
    });

    // Gallery select
    el('simGallerySelect')?.addEventListener('change', e => {
        markInteracted();
        state.galleryCategory = e.target.value;
        state.sliderIndex     = 0;
        renderSlider();
    });

    // Slider controls
    el('simPrevBtn')?.addEventListener('click', prevSlide);
    el('simNextBtn')?.addEventListener('click', () => nextSlide(true));

    // Drawer close
    el('simCloseBtn')?.addEventListener('click', closeDrawer);
    el('simBackdrop')?.addEventListener('click', closeDrawer);

    // Drawer selects
    el('simSelectCategory')?.addEventListener('change', e => {
        state.selectedCategory = e.target.value;
        state.selectedProperty = CATEGORIES_DATA[e.target.value][0];
        state.selectedUnit     = state.selectedProperty.units[0];
        populateProperties();
    });

    el('simSelectProperty')?.addEventListener('change', e => {
        state.selectedProperty = CATEGORIES_DATA[state.selectedCategory].find(p => p.id === e.target.value);
        state.selectedUnit     = state.selectedProperty.units[0];
        populateUnits();
    });

    el('simSelectUnit')?.addEventListener('change', e => {
        state.selectedUnit = state.selectedProperty.units.find(u => u.name === e.target.value);
        updateCalc();
    });

    // Entry % buttons
    el('simEntryGroup')?.addEventListener('click', e => {
        const btn = e.target.closest('[data-entry]');
        if (!btn) return;
        state.entryPercentage = parseInt(btn.dataset.entry, 10);
        updateCalc();
    });

    // Term buttons
    el('simTermGroup')?.addEventListener('click', e => {
        const btn = e.target.closest('[data-term]');
        if (!btn) return;
        state.paymentTerm = parseInt(btn.dataset.term, 10);
        updateCalc();
    });

    // Reinforcement toggle
    el('simRefToggle')?.addEventListener('click', e => {
        const btn = e.target.closest('[data-ref]');
        if (!btn) return;
        state.hasReinforcements = btn.dataset.ref === 'true';
        updateCalc();
    });

    // Lead form
    el('simLeadForm')?.addEventListener('submit', submitLead);
    el('simResetBtn')?.addEventListener('click', resetLead);

    // Escape key closes drawer
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeDrawer();
    });

    // Pause autoplay on gallery hover
    const gallery = document.querySelector('.sim-gallery');
    gallery?.addEventListener('mouseenter', stopAutoplay);
    gallery?.addEventListener('mouseleave', startAutoplay);

    // Re-render on resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(renderSlider, 150);
    });

    // ── URL param auto-open ────────────────────────────────────────────────
    const paramUnit = new URLSearchParams(window.location.search).get('unit');

    if (paramUnit) {
        let found = null;

        outer: for (const [cat, props] of Object.entries(CATEGORIES_DATA)) {
            for (const prop of props) {
                const unit = prop.units.find(u => buildUnitParam(cat, u.name) === paramUnit);
                if (unit) {
                    found = { cat, prop, unit };
                    break outer;
                }
            }
        }

        if (found) {
            state.selectedCategory  = found.cat;
            state.selectedProperty  = found.prop;
            state.selectedUnit      = found.unit;
            state.galleryCategory   = found.cat;
            state.sliderIndex       = 0;
            state.entryPercentage   = 25;
            state.paymentTerm       = 55;
            state.hasReinforcements = true;

            renderSlider();
            openDrawer();
        }
    }
});
